import React from "react";

const RouterContext = React.createContext({
  changeNavType: (val: any) => {},
});

export default RouterContext;
